import { Form } from 'antd';

const MASKED_VALUE = '********';

// 編輯模式下密碼欄位的眼睛開關規則：
// - 新建模式 (isEditing=false)：永遠允許切換
// - 編輯模式且欄位仍為遮罩值（未重輸入）：關閉眼睛，避免使用者誤以為點擊能還原密文
// - 編輯模式且使用者已輸入新值：允許切換以便確認輸入
export const useDirtyMaskedField = (form, fieldPath, isEditing) => {
  const value = Form.useWatch(fieldPath, form);
  if (!isEditing) return true;
  return !!value && value !== MASKED_VALUE;
};
